import type { ReactNode } from "react";
import type { ActivityOutcomeKind } from "@common/schemas/domains/activity/activity-outcomes.schema";
import { ActivitySeries } from "@common/schemas/domains/activity/activity-timeline.schema";
import { ActivityFiltersBar } from "@components/activityTimeline/filters/ActivityFiltersBar";
import type {
    OrganizationActivityFilters,
    OrganizationActivitySelection,
} from "./organizationActivityFilters.types";
import { useOrganizationFilterTabs } from "./organizationFilterTabs";

interface OrganizationActivityToolbarProps {
    search: string | undefined;
    selection: OrganizationActivitySelection;
    pickableSeries: readonly ActivitySeries[];
    pickableOutcomes: readonly ActivityOutcomeKind[];
    clientWorkspaceIds: string[] | undefined;
    isChannelFilterEnabled: boolean;
    onSelectionChange: (next: Partial<OrganizationActivityFilters>) => void;
    onClearFilters?: () => void;
    /** The right-hand controls: density, the date button, then Clients. */
    children: ReactNode;
}

/** The firm Activity toolbar; renders inside the page's people provider, which Updated by reads. */
export const OrganizationActivityToolbar = ({
    search,
    onSelectionChange,
    onClearFilters,
    children,
    ...tabParams
}: OrganizationActivityToolbarProps) => {
    const tabs = useOrganizationFilterTabs({
        ...tabParams,
        onChange: onSelectionChange,
    });
    return (
        <ActivityFiltersBar
            search={search}
            onSearchChange={(next) => onSelectionChange({ search: next })}
            tabs={tabs}
            onClearFilters={onClearFilters}
        >
            {children}
        </ActivityFiltersBar>
    );
};
